var React = require('react');

function NavIconSms (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.9375 0C2.97227 0 2.1875 0.784766 2.1875 1.75V12.25C2.1875 13.2152 2.97227 14 3.9375 14H10.0625C11.0277 14 11.8125 13.2152 11.8125 12.25V1.75C11.8125 0.784766 11.0277 0 10.0625 0H3.9375ZM6.125 11.8125H7.875C8.11563 11.8125 8.3125 12.0094 8.3125 12.25C8.3125 12.4906 8.11563 12.6875 7.875 12.6875H6.125C5.88437 12.6875 5.6875 12.4906 5.6875 12.25C5.6875 12.0094 5.88437 11.8125 6.125 11.8125Z","fill":"currentColor"}));
}

NavIconSms.defaultProps = {"viewBox":"0 0 14 14","fill":"currentColor"};

module.exports = NavIconSms;

NavIconSms.default = NavIconSms;
